import { render, staticRenderFns } from "./componentMatrixReport.vue?vue&type=template&id=5ba60aa6&scoped=true"
import script from "./componentMatrixReport.vue?vue&type=script&lang=js"
export * from "./componentMatrixReport.vue?vue&type=script&lang=js"
import style0 from "./componentMatrixReport.vue?vue&type=style&index=0&id=5ba60aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba60aa6",
  null
  
)

export default component.exports